import type { FunctionComponent } from 'react';

import useAlliumStatusContent from './useAlliumStatusContent';

import Generic from '../../StatusComponent/Generic';
import Specific from '../../StatusComponent/Specific';
import { LenderStatus } from '../constants';

const renderAlliumContent = (state?: LenderStatus): JSX.Element => {
  switch (state) {
    case 'referred':
      return <Generic.Referred />;
    case 'pending':
      return <Specific.Allium.Pending />;
    case 'declined':
      return <Generic.Declined />;
    case 'not_approved':
      return <Generic.Declined />;
    case 'under_review':
      return <Generic.UnderReview />;
    case 'action_required':
      return <Generic.ActionRequired />;
    case 'loading':
      return <Generic.Loading />;
    case 'sign_documents':
      return <Specific.Allium.SignDocuments />;
    case 'deposit':
      return <Generic.Deposit />;
    case 'ready_to_start':
      return <Generic.ReadyToStart />;
    case 'sat_note':
      return <Generic.SatNote />;
    case 'sat_note_delayed':
      return <Generic.SatNoteDelayed />;
    case 'finished':
      return <Generic.Finished />;
    case 'cancelled':
      return <Generic.Cancelled />;
    default:
      return <Generic.Referred />;
  }
};

const AlliumStatusContent: FunctionComponent = () => {
  const { state } = useAlliumStatusContent();
  return (
    <div className="flex flex-col w-full">{renderAlliumContent(state)}</div>
  );
};

export default AlliumStatusContent;
